/**
 * ...
 * @author Robert Lombardo, Wakefield Studios ( rob@wakefield-studios.com )
 */
const Q_buff_ally = require('./Q_buff_ally');
const Q_full_AP = require('./Q_full_AP');
const UseAbility = require('../UseAbility');
const BattleCalc = require('../../BattleCalc');
const AStarSearch = require('../../ai/AStarSearch/AStarSearch');

const _a_star_search = new AStarSearch();

const Q_ally_no_poisoner = function (actor, battleState) {
  const node = new Q_buff_ally('poison_weapon', actor, battleState);

  node.branches[node.NO] = new Q_full_AP(actor, battleState);
  node.branches[node.YES] = new UseAbility(actor, 'poison_weapon');

  const poison_weapon = BattleCalc.getEquippedAbility(actor, 'poison_weapon');
  const leap = BattleCalc.getEquippedAbility(actor, 'leap');
  const teleport = BattleCalc.getEquippedAbility(actor, 'teleport');
  const move = BattleCalc.getEquippedAbility(actor, 'move');

  node.getUnitWithoutBuff = function () {
    const blessedFactor = BattleCalc.getBlessedFactor(actor);

    for (const ally of BattleCalc.getAlliesOfUnit(
      actor,
      battleState.allUnits
    )) {
      if (
        !BattleCalc.getCondition(ally, node.buffCondition) &&
        // ally is adjacent or can be reached by leap/teleport
        (BattleCalc.adjacent(actor, ally) ||
          ((leap || teleport) && !BattleCalc.isSurrounded(ally, battleState)) ||
          // has enough AP to move to ally and poison weapon (and there is a path)
          (actor.ap >
            BattleCalc.boardDistance(actor, ally) *
              move.apCost *
              blessedFactor +
              poison_weapon.apCost * blessedFactor &&
            _a_star_search.getPath(actor, ally, battleState).length > 1))
      ) {
        return ally;
      }
    }

    return null;
  };

  return node;
};
module.exports = Q_ally_no_poisoner;
